import React, {useState} from "react";
import MainButton from "../../commons/mainButton";
import Loader from "../../commons/loader";
import {GLOBAL_BORDER_RADIUS} from "../../../costants";
import MyNormalText from "../../commons/myNormalText";
import {httpsCallable} from "firebase/functions";
import {functions} from "../../../firebase";

function Maintenance({rentUser, rents, premiumPalette}) {

    const primaryColor = premiumPalette.primaryColor;
    const primaryColorFirstAlternative = premiumPalette.primaryColorFirstAlternative;

    const [loading, setLoading] = useState(false)

    function handleCleanOldDates(rentIdTarget) {
        setLoading(true)

        const request = {
            rentId: rentUser.rentId,
            rentIdTarget: rentIdTarget
        }

        const rentSuperUserAdminMaintenanceCleanOldDatesCommand = httpsCallable(functions, 'rentSuperUserAdminMaintenanceCleanOldDatesCommand')
        rentSuperUserAdminMaintenanceCleanOldDatesCommand(request)
            .then(() => setLoading(false))
            .catch(() => setLoading(false))
    }

    return (
        <div style={{...pageStyle.rentContainer, backgroundColor: primaryColor}}>
            {loading ?
                <Loader absoluteFullPage={true}/> :
                <></>}
            <div style={{marginBottom: 10}}>
                <MyNormalText text={'Pulizia vecchie rentedDays per noleggio'}
                              fontSize={18}
                              bold={true}/>
            </div>
            <div style={{display: 'flex', flexWrap: 'wrap', gap: 10}}>
                {rents.map(rent => {
                    return (
                        <div key={rent.rentId}>
                            <MainButton text={rent.name}
                                        action={() => handleCleanOldDates(rent.rentId)}
                                        backgroundColor={primaryColorFirstAlternative}/>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

const pageStyle = {
    rentContainer: {
        padding: 10,
        borderRadius: GLOBAL_BORDER_RADIUS
    }
};

export default Maintenance;
